var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 543.4 161.15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 96.24,
    y1: 20.22,
    x2: 96.24,
    y2: 181.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#43ffbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#144b46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 288.81,
    y1: 9.86,
    x2: 280.16,
    y2: 58.89,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 288.81,
    y1: 76.28,
    x2: 280.16,
    y2: 125.3,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 288.81,
    y1: 142.69,
    x2: 280.16,
    y2: 191.71,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 535.15,
    y1: 9.12,
    x2: 429.71,
    y2: 191.75,
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M28.6,21.22a6.83,6.83,0,0,0-6.83,6.83V40.7a6.83,6.83,0,0,0,6.83,6.83H91.14a53.27,53.27,0,0,1,53.17,50.22A52.34,52.34,0,0,1,130,137a55.07,55.07,0,0,1-39.89,17.06H28.6a6.83,6.83,0,0,0-6.83,6.83v12.65a6.83,6.83,0,0,0,6.83,6.83H89.9c43.92,0,80.17-35.16,80.8-78.39A79.64,79.64,0,0,0,91.14,21.22H28.6",
    transform: "translate(-20.77 -20.22)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "e1",
    d: "M222.14,21.22a6.84,6.84,0,0,0-6.84,6.83V40.7a6.84,6.84,0,0,0,6.84,6.83H346.83a6.84,6.84,0,0,0,6.84-6.83V28.05a6.84,6.84,0,0,0-6.84-6.83H222.14",
    transform: "translate(-20.77 -20.22)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M222.14,87.63a6.85,6.85,0,0,0-6.84,6.84v12.64a6.85,6.85,0,0,0,6.84,6.84H346.83a6.85,6.85,0,0,0,6.84-6.84V94.47a6.85,6.85,0,0,0-6.84-6.84H222.14",
    transform: "translate(-20.77 -20.22)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M222.14,154.05a6.84,6.84,0,0,0-6.84,6.83v12.65a6.84,6.84,0,0,0,6.84,6.83H346.83a6.84,6.84,0,0,0,6.84-6.83V160.88a6.84,6.84,0,0,0-6.84-6.83H222.14",
    transform: "translate(-20.77 -20.22)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M447.85,21.22A46.41,46.41,0,0,0,401.5,68.65c.56,25,21.75,45.3,47.24,45.3H516.8a20.16,20.16,0,0,1,20,18.44,19.55,19.55,0,0,1-5.19,15,21.08,21.08,0,0,1-15.47,6.69H413.82a6.84,6.84,0,0,0-6.84,6.83v12.65a6.84,6.84,0,0,0,6.84,6.83H515.91c25.49,0,46.68-20.32,47.24-45.3A46.41,46.41,0,0,0,516.8,87.63H447.85a20.14,20.14,0,0,1-20-18.44,19.58,19.58,0,0,1,5.18-15,21.1,21.1,0,0,1,15.47-6.69H552.28a6.84,6.84,0,0,0,6.83-6.83V28.05a6.84,6.84,0,0,0-6.83-6.83H447.85",
    transform: "translate(-20.77 -20.22)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "url(#e)"
  })));
}

export default SvgDes;